import React, { useEffect } from 'react';
import { getVisitorId } from '../utils/utils';
import getUserAttributes from '../utils/getUserAttributes';
import { OptimizelyProvider } from '@optimizely/react-sdk';
import { shape, object, bool, node, string } from 'prop-types';

const propTypes = {
    optimizely: shape({
        initialConfig: shape({
            datafile: object
        })
    }),
    isServerSide: bool.isRequired,
    children: node.isRequired,
    pageGroup: string.isRequired,
    nativeapp: string
};

const Provider = props => {
    const { optimizely, isServerSide, children, pageGroup, nativeapp } = props;
    const initialUserAttributes = typeof window !== 'undefined' ? getUserAttributes({}, pageGroup, nativeapp) : {};
    const visitorId = getVisitorId();
    useEffect(() => {
        const getUserSummary = async () => {
            const userSummary = await window.SF?.getUserSummary();
            userSummary &&
                optimizely.setUser({
                    id: optimizely.user.id,
                    attributes: {
                        ...optimizely.user.attributes,
                        ...getUserAttributes(userSummary, pageGroup, nativeapp)
                    }
                });
        };
        getUserSummary();
    }, [visitorId, pageGroup]);
    return optimizely?.initialConfig?.datafile ? (
        <OptimizelyProvider optimizely={optimizely} user={{ id: visitorId, attributes: initialUserAttributes }} isServerSide={isServerSide}>
            {children}
        </OptimizelyProvider>
    ) : (
        <>{children}</>
    );
};

Provider.propTypes = propTypes;

export default Provider;
